import React, { Component } from 'react';

class Browse extends Component {
    render() {
        return (
            <div className="Browse">
                <h1>Browse</h1>
            </div>
            );
    }
}

export default Browse;


// WEBPACK FOOTER //
// ./src/Components/Browse/Browse.js